import React, { Component } from "react";
import { apiCall } from '../../helpers/api'

class TestAI extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.getAuthorization()
    }

    async getAuthorization() {
        var response = await apiCall("session/sign",{ "method" : "GET" })
        if (response["success"]) {
            var signedSession = response["success"]["signedSession"]
            console.log(signedSession)
            var aiResponse = await fetch("http://localhost:5511/api/1.0/ai/simple", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "room-signed-session" : signedSession
                },
                body: JSON.stringify({ 
                    system : "Say Hello",
                    user : "Hello"
                })
            });
            var aiResult = await aiResponse.json();
            console.log(aiResult);
        }
    }

    render() {
        return (
            <>
                <h1>Test AI</h1>
            </>
        );
    }
}

export default function (props) {
    return <TestAI />;
}
